export const fontsOptions = [
  {
    value: 'sans-serif',
    label: 'Sans-serif',
  },
  {
    value: 'FS Sinclair Trial',
    label: 'FS Sinclair Trial',
  },
  {
    value: 'SF Pro Display',
    label: 'SF Pro Display',
  },
  {
    value: 'Open Sans',
    label: 'Open Sans',
  },
  {
    value: 'Helvetica Neue',
    label: 'Helvetica Neue',
  },
  {
    value: 'Poppins',
    label: 'Poppins',
  },
  {
    value: 'Arial',
    label: 'Arial',
  },
];
